export const ocplcUploadFile = `mutation uploadFile($file: Upload!) {
  uploadFile(file: $file) {
    message
    fileErrorContent
  }
}`;